import React, { forwardRef, ForwardRefExoticComponent, RefAttributes } from 'react';
import cns from 'classnames';
import styles from './Select.module.scss';

export interface ISelectProps extends RefAttributes<HTMLSelectElement> {
  className?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  value?: string | number;
  disabled?: boolean;
  options?: { value: string | number; label: string }[];
}

const Select: ForwardRefExoticComponent<ISelectProps> = forwardRef(
    ({ className, onChange, value, disabled, options, ...rest }, ref) => (
      <select
        ref={ref}
        className={cns(styles.select, className)}
        onChange={onChange}
        value={value}
        disabled={disabled}
        {...rest}
      >
        {options?.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        )) ?? null}
      </select>
    )
  );
  

export default Select;
